import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sciences',
  templateUrl: './sciences.component.html',
  styleUrls: ['./sciences.component.css']
})
export class SciencesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
